import { Box, Divider, Typography } from '@mui/material';

import { SUMMARY_SX } from '../styles';
import { formatEvvDate, getEvvFallbackReasonLabel } from '../utils';
import { EvvSideSummary } from './EvvSideSummary';

import type { EvvHistoryDetailsProps } from '../types';

export function EvvHistoryDetails({ history }: EvvHistoryDetailsProps) {
  return (
    <>
      <Box sx={SUMMARY_SX}>
        <EvvSideSummary label="Start" side={history.start} />
        <EvvSideSummary label="End" side={history.end} />
      </Box>
      <Divider sx={{ my: 2 }} />
      <Typography variant="h6">Capture attempts</Typography>
      {!history.capture_attempts.length && (
        <Typography color="text.secondary">No capture attempts</Typography>
      )}
      {history.capture_attempts.map((attempt) => (
        <Box key={attempt.id} sx={{ py: 1, overflowWrap: 'anywhere' }}>
          <Typography variant="body2">
            Attempt {attempt.id} · Token {attempt.token_id ?? '—'} · {attempt.kind} ·{' '}
            {attempt.status}
          </Typography>
          <Typography variant="body2">Time: {formatEvvDate(attempt.attempted_at)}</Typography>
          <Typography variant="body2">Latitude: {attempt.lat ?? '—'}</Typography>
          <Typography variant="body2">Longitude: {attempt.long ?? '—'}</Typography>
          <Typography variant="body2">
            Accuracy: {attempt.accuracy_meters ?? '—'} meters
          </Typography>
          <Typography variant="body2">Device: {attempt.device_info ?? '—'}</Typography>
          {attempt.fallback_reason && (
            <Typography variant="body2">
              Reason: {getEvvFallbackReasonLabel(attempt.fallback_reason)}
            </Typography>
          )}
          {attempt.failure_reason && (
            <Typography color="error" variant="body2">
              {attempt.failure_reason}
            </Typography>
          )}
        </Box>
      ))}
      <Divider sx={{ my: 2 }} />
      <Typography variant="h6">Token history</Typography>
      <Typography color="text.secondary" variant="body2">
        Newest first. Stored status can remain active after the expiry time.
      </Typography>
      {!history.tokens.length && <Typography color="text.secondary">No token history</Typography>}
      {history.tokens.map((token) => (
        <Box key={token.id} sx={{ py: 1 }}>
          <Typography variant="body2">
            Token {token.id} · {token.kind} · Stored status: {token.status} · Effective:{' '}
            {token.effective_status}
          </Typography>
          <Typography variant="body2">Expires: {formatEvvDate(token.expires_at)}</Typography>
          <Typography variant="body2">Captured: {formatEvvDate(token.captured_at)}</Typography>
        </Box>
      ))}
    </>
  );
}
